






































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  name: 'respondeco-dialog',
  components: { RespondecoIcon },
})
export default class RespondecoDialog extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly adaptive!: boolean

  @Prop({
    default: () => [],
    type: Array,
  })
  public readonly buttons!: any[]

  @Prop({
    default: true,
    type: Boolean,
  })
  public readonly clickToClose!: boolean

  @Prop({
    default: 'auto',
    type: [Number, String],
  })
  public readonly height!: number | string

  @Prop({
    type: String,
  })
  public readonly name!: string

  @Prop({
    default: true,
    type: Boolean,
  })
  public readonly scrollable!: boolean

  @Prop({
    type: String,
  })
  public readonly title!: string

  @Prop({
    default: 400,
    type: [Number, String],
  })
  public readonly width!: number | string

  public $refs!: {
    dialog: any
  }

  public emitBeforeOpen(event: any) {
    this.$emit('before-open', event)
  }

  @Watch('height')
  public onHeightChanged(value: number | string) {
    // hack because the height and width are not reactive
    this.$refs.dialog._data.modal.height = value
  }

  @Watch('width')
  public onWidthChanged(value: number | string) {
    // hack because the height and width are not reactive
    this.$refs.dialog._data.modal.width = value
  }
}
